 // var quantity = _VARIANTS[variant.id];
// if (!quantity) {
       //     quanrtity = 0
       //   }
           
       //   if (variant.inventory_management == "shopify" && variant.inventory_policy != "continue")
       //   {
       //     if ( quantity > 0){
       //       jQuery('#variant-inventory').text( 'Available: ' + quantity + ' in stock.');
       //       jQuery('#variant-inventory2').text('Delivered next day (if ordered before 1pm).');
       //     }
       //     else {
       //       jQuery('#variant-inventory').text( 'Available: Print on demand.');
       //       jQuery('#variant-inventory2').text('Delivered next week.');
       //     }
       //   } else {
       //     jQuery('#variant-inventory').text("This product is available");
       //   }
       // } else {
       //   jQuery('#variant-inventory').text('quantity undefined for price ' + variant.price);
       // }

$('.cst_fil_heading').click(function(){
            $(".toggle_filters").slideToggle();
            $(".cst_fil_heading .has_cls img.carret_down").toggleClass("has_transform");
          })

        if (window.matchMedia('(min-width: 769px)').matches) {
          $('.shopify_fil .fil_inner').click(function(){
            $('.up_filter').show();
            $(this).hide();
          })

          $(document).on("click", ".click_toggle_btn .fill_title", function () {
          // $('.click_toggle_btn .fill_title').click(function(){
            $('.up_filter').hide();
            $('.shopify_fil .fil_inner').show();
          })
        }
        if (window.matchMedia('(max-width: 768px)').matches) {
          // $('.fill_title').click(function(){
          //   $('.hidden_showing').slideToggle();
          //   $(this).toggleClass("wrap_icon");
          // })
        }

// Slider mobile product images

    $('.mobslider').slick({
        slidesToShow: 1,
        autoplay: false,
        dots: true,
        dotsClass: 'custom_paging',
        nextArrow: "<button class='slide-arrow next-arrow custnxt'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-caret' viewBox='0 0 10 6'><path fill-rule='evenodd' clip-rule='evenodd' d='M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z' fill='currentColor'></path></svg></button>",
        prevArrow: "<button class='slide-arrow prev-arrow custprev'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-caret' viewBox='0 0 10 6'><path fill-rule='evenodd' clip-rule='evenodd' d='M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z' fill='currentColor'></path></svg></button>",
        customPaging: function (slider, i) {
            console.log(slider);
            return  (i + 1) + '/' + slider.slideCount;
        }
    });

// Popup form
  
    

//cache for same position in collection page
jQuery(document).on("click", "#AjaxinateLoop a", function (e) {
 snapbackCache.cachePage();
});

jQuery("#AjaxinateLoop").on("snapback-cache:loaded", function(e, cachedPage) {
  // sets the pager to page from the appropriate place
  EndlessPage.offset = cachedPage.nextPageOffset
});